// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3146":"bf84afeaaa74af3e","4648":"818f9726fe1fa53a","9381":"8f4701fe9de8255a"}[chunkId] + ".css";
};